export default {"src":"/_next/static/media/infoTooltipDisabled.d7c71f2a.svg","height":18,"width":17};